import { makeStyles } from "@material-ui/core"

export const useStyles = makeStyles((theme) => ({
    descontoLabel: {
        '& label': {
            fontSize: '.8rem'
        }
    }
}));